import * as msal from '@azure/msal-browser';
import AuthConfig, { apiTokenRequest } from '../app_config/authConfig';
import GnavAuthConfig from '../app_config/gnavAuthConfig';

import EnvConfig from '../app_config/envConfig';
import apiConfig from '../app_config/apiConfig';
import Store from '../store/store';
import { LOGIN, LOGOUT, SET_CLIENT_DATA_TOGGLE } from '../constants/reducerTypes';
import UtilityService from './utilityService';

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const isIE = msie > 0 || msie11 > 0;

let userProfile;
let signInType;

// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
// const AuthConfig = GnavAuthConfig;
// const myMSALObj = new msal.PublicClientApplication(AuthConfig.msalConfig);

const myMSALObj = new msal.PublicClientApplication(AuthConfig.msalConfig);
let gnavAccessToken;
const signIn = async method => {
  signInType = isIE ? 'loginRedirect' : method;
  if (signInType === 'loginPopup') {
    return await myMSALObj
      .loginPopup(AuthConfig)
      .then(handleResponse)
      .catch(function(error) {
        console.log(error);
      });
  }
  if (signInType === 'loginRedirect') {
    return myMSALObj.loginRedirect(AuthConfig);
  }
};

const signOut = () => {
  const userProfile = window.localStorage.getItem('userProfile')
    ? JSON.parse(window.localStorage.getItem('userProfile'))
    : null;
  const spoToken = userProfile ? userProfile.spoToken : '';
  const accountId = userProfile ? userProfile.accountId : '';
  const logoutRequest = {
    account: myMSALObj.getAccountByHomeId(accountId),
    postLogoutRedirectUri: window.location.origin + '/#logout',
  };
  userLogout(spoToken, accountId);
  Store.dispatch({
    type: LOGOUT,
  });
  return myMSALObj.logoutPopup(logoutRequest);
};

const getTokenPopup = async (request, account) => {
  request.account = account;
  const authConfigScope = request.scopes;
  request.scopes = GnavAuthConfig.scopes;
  const loginResponse = await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
  if (loginResponse !== undefined) {
    gnavAccessToken = loginResponse.accessToken;
    /* Store.dispatch({
        type: LOGIN,
        payload: userProfile,
      }); */
  }
  request.scopes = authConfigScope;
  return await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      console.log('acquiring token using popup');
      return myMSALObj.acquireTokenPopup(request).catch(error => {
        console.error(error);
      });
    }
    console.error(error);
  });
};

// This function can be removed if you do not need to support IE
const getTokenRedirect = async (request, account) => {
  request.account = account;
  const authConfigScope = request.scopes;
  request.scopes = GnavAuthConfig.scopes;
  const loginResponse = await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
  if (loginResponse !== undefined) {
    gnavAccessToken = loginResponse.accessToken;
  }
  request.scopes = authConfigScope;
  return await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
};

//This is used to silently acquire access token for Custom scope (Sharepoint access)
const getTokenAcquireAsync = async () => {
  const { email } = Store.getState().authenticationData.userDetails;
  const account = myMSALObj.getAccountByUsername(email);

  isIE
    ? await getTokenRedirect(AuthConfig, account)
        .then(handleResponse)
        .catch(error => console.log('silent authentication error ', error))
    : await getTokenPopup(AuthConfig, account)
        .then(handleResponse)
        .catch(error => console.log('popup authentication error ', error));
};

const acquireTokenWithRetry = async () => {
  const { email } = Store.getState().authenticationData.userDetails;
  const account = myMSALObj.getAccountByUsername(email);
  AuthConfig.account = account;
  try {
    // Try popup first
    await myMSALObj.acquireTokenPopup(AuthConfig);
  } catch (error) {
    console.warn('Popup failed, falling back to redirect:', error);
    myMSALObj.acquireTokenRedirect(AuthConfig);
  }
};

const getUserRoles = async (token, mdwtoken) => {
  const url = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.getUserRoles.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.getUserRoles.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      mdwauthorization: mdwtoken,
    },
  };
  const response = await fetch(url, options);
  if (!response.ok) {
    throw response;
  }
  const data = await response.json();
  return data;
};

const handleResponse = async resp => {
  if (resp) {
    const readToken = { accessToken: resp.accessToken, expiresOn: resp.expiresOn };
    let response = '';
    if (isIE) {
      response = await getTokenRedirect(apiTokenRequest, resp.account);
    } else {
      response = await getTokenPopup(apiTokenRequest, resp.account);
    }
    if (response) {
      const spoToken = await getSpoToken(response.accessToken, response.account).catch(error =>
        console.log('Error in getting SPO token ', error),
      );
      const TokenAndFlag = await getMdwTokenAndFlag(
        response.accessToken,
        response.account,
      ).catch(error => console.log('Error in getting MDW token ', error));
      const DPFToken = await getdpfToken(response.accessToken, response.account).catch(error =>
        console.log('Error in getting DPF token ', error),
      );
      const TDSToken = await getTdsToken(response.accessToken, response.account).catch(error =>
        console.log('Error in getting TDS token ', error),
      );

      let userRoles = [];
      if (TokenAndFlag?.isClientDataAccess) {
        try {
          const roles = await getUserRoles(response.accessToken, TokenAndFlag?.mdwToken);
          userRoles = roles?.roles || [];
        } catch (error) {
          console.log('Error in getting user roles ', error);
          userRoles = [];
        }
      }

      if (spoToken) {
        const expiresOn = Math.min(
          new Date(readToken.expiresOn).getTime(),
          new Date(response.expiresOn).getTime(),
          new Date(spoToken.expiresOn).getTime(),
        );
        dispatchUserProfile({
          ...response,
          expiresOn,
          readToken: readToken.accessToken,
          spoToken: spoToken.accessToken,
          isClientDataAccess: TokenAndFlag?.isClientDataAccess || false,
          mdwToken: TokenAndFlag?.mdwToken,
          dpfToken: DPFToken?.accessToken,
          tdsToken: TDSToken?.accessToken,
          roles: userRoles || [],
        });
      }
      // workaround for running the application with local environment
      else if (process.env.REACT_APP_ENVIRONMENT_NAME === 'local') {
        const expiresOn = Math.min(
          new Date(readToken.expiresOn).getTime(),
          new Date(response.expiresOn).getTime(),
        );
        dispatchUserProfile({
          ...response,
          expiresOn,
          readToken: readToken.accessToken,
          spoToken: '',
          isClientDataAccess: TokenAndFlag?.isClientDataAccess || false,
          mdwToken: TokenAndFlag?.mdwToken || false,
          dpfToken: DPFToken?.accessToken,
          tdsToken: TDSToken?.accessToken,
          roles: userRoles || [],
        });
      }
    }
  } else if (window.location.hash.indexOf('logout') < 0 && UtilityService.checkTokenExpiry()) {
    localStorage.clear();
    await signIn('loginRedirect');
  }
};

const getSpoToken = async (bearerToken, accountInfo) => {
  const spoUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.getSpoToken.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.getSpoToken.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AccountId: accountInfo && accountInfo.homeAccountId ? accountInfo.homeAccountId : '',
      Authorization: `Bearer ${bearerToken}`,
    },
  };
  const response = await fetch(spoUrl, options).catch(error => {
    throw error;
  });
  const spoTokenRes = await response;
  if (spoTokenRes.ok) {
    const spoToken = spoTokenRes.json();
    return spoToken;
  }
  // eslint-disable-next-line no-else-return
  else {
    throw spoTokenRes;
  }
};

const getMdwTokenAndFlag = async (bearerToken, accountInfo) => {
  const spoUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.FetchMdwToken.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.FetchMdwToken.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AccountId: accountInfo && accountInfo.homeAccountId ? accountInfo.homeAccountId : '',
      Authorization: `Bearer ${bearerToken}`,
    },
  };
  const response = await fetch(spoUrl, options).catch(error => {
    throw error;
  });
  const MDWTokenResponse = await response;
  if (MDWTokenResponse.ok) {
    const MDWTokenRes = MDWTokenResponse.json();
    return MDWTokenRes;
  }
  // eslint-disable-next-line no-else-return
  else {
    throw MDWTokenResponse;
  }
};

const getdpfToken = async (bearerToken, accountInfo) => {
  const spoUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.getdpfToken.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.getdpfToken.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AccountId: accountInfo && accountInfo.homeAccountId ? accountInfo.homeAccountId : '',
      Authorization: `Bearer ${bearerToken}`,
    },
  };
  const response = await fetch(spoUrl, options).catch(error => {
    throw error;
  });
  const DPFTokenResponse = await response;
  if (DPFTokenResponse.ok) {
    const DPFTokenRes = DPFTokenResponse.json();
    return DPFTokenRes;
  }
  // eslint-disable-next-line no-else-return
  else {
    throw DPFTokenResponse;
  }
};

const getTdsToken = async (bearerToken, accountInfo) => {
  const tdsUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.getTdsToken.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.getTdsToken.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AccountId: accountInfo && accountInfo.homeAccountId ? accountInfo.homeAccountId : '',
      Authorization: `Bearer ${bearerToken}`,
    },
  };
  const response = await fetch(tdsUrl, options).catch(error => {
    throw error;
  });
  const TDSTokenResponse = await response;
  if (TDSTokenResponse.ok) {
    const TDSTokenRes = TDSTokenResponse.json();
    return TDSTokenRes;
  }
  // eslint-disable-next-line no-else-return
  else {
    throw TDSTokenResponse;
  }
};

const userLogout = async (spoToken, accountId) => {
  const userProfile = window.localStorage.getItem('userProfile')
    ? JSON.parse(window.localStorage.getItem('userProfile'))
    : null;
  const accessToken = userProfile ? userProfile.accessToken : '';
  const apiUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${
    apiConfig.endpointConfig.userLogout.endpoint
  }`;
  const options = {
    method: `${apiConfig.endpointConfig.userLogout.method}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AccountId: accountId ? accountId : '',
      Authorization: `Bearer ${accessToken}`,
      spoauthorization: spoToken ? spoToken : '',
    },
  };
  fetch(apiUrl, options).catch(error => {
    throw error;
  });
};

const getAppVersion = async () => {
  try {
    const res = await fetch('/manifest.json');
    if (!res.ok) return '';
    const data = await res.json();
    return data['App Version'] || '';
  } catch (err) {
    return '';
  }
};

const dispatchUserProfile = async payloadObj => {
  let profileUrl = EnvConfig.peopleProfile.baseUrl + apiConfig.endpointConfig.peopleProfile.params;
  profileUrl = profileUrl ? profileUrl.replace('{email}', payloadObj.account.username) : '#';
  const incomingRoles = Array.isArray(payloadObj.roles) ? payloadObj?.roles : [];
  const roles = [];
  incomingRoles.forEach(r => {
    const name = r && r.roleName ? String(r.roleName).toLowerCase() : '';
    if (name.includes('producer')) roles.push('Producer');
    if (name.includes('governance')) roles.push('Governor');
  });
  const appVersion = await getAppVersion();
  const isClientDataAccess = payloadObj.isClientDataAccess;
  userProfile = {
    profileUrl,
    displayName: payloadObj.account.name,
    email: payloadObj.account.username,
    accountId: payloadObj.account.homeAccountId,
    accessToken: payloadObj.accessToken,
    readToken: payloadObj.readToken,
    tokenType: payloadObj.tokenType,
    scopes: payloadObj.scopes,
    expiresOn: payloadObj.expiresOn,
    spoToken: payloadObj.spoToken,
    account: payloadObj.account,
    gnavAccessToken,
    mdwToken: payloadObj.mdwToken,
    isClientDataAccess,
    dpfToken: payloadObj.dpfToken,
    tdsToken: payloadObj.tdsToken,
    roles,
    appVersion
  };
  Store.dispatch({
    type: LOGIN,
    payload: userProfile,
  });
  Store.dispatch({
    type: SET_CLIENT_DATA_TOGGLE,
    payload: isClientDataAccess || false,
  });
};
const currentUserAccount = () => {
  const { email } = Store.getState().authenticationData.userDetails;
  const account = myMSALObj.getAccountByUsername(email);
  return account;
};
// Redirect: once login is successful and redirects with tokens, call Graph API

myMSALObj
  .handleRedirectPromise()
  .then(handleResponse)
  .catch(err => {
    console.error(err);
  });

const exportObj = {
  signIn,
  getTokenAcquireAsync,
  signOut,
  currentUserAccount,
  acquireTokenWithRetry,
};
export default exportObj;
